import { render } from "./ModuleSearch.vue?vue&type=template&id=018a16e6&scoped=true"
import script from "./ModuleSearch.vue?vue&type=script&lang=js"
export * from "./ModuleSearch.vue?vue&type=script&lang=js"

import "./ModuleSearch.vue?vue&type=style&index=0&id=018a16e6&lang=scss&scoped=true"
import "./ModuleSearch.vue?vue&type=style&index=1&id=018a16e6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018a16e6"]])

export default __exports__